import { render, staticRenderFns } from "./pluxeeSales.vue?vue&type=template&id=4ffe5aff&scoped=true&"
import script from "./pluxeeSales.vue?vue&type=script&lang=js&"
export * from "./pluxeeSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffe5aff",
  null
  
)

export default component.exports